'use client';
import { ISingleOrder } from '@/entities/order/model/types';
import { NumberToPrice } from '@/features/number-to-price';
import RightIcon from '@/shared/assets/icons/right';
import { getStatus, getStatusName } from '@/shared/lib/get-status';

import { Badge, HStack, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { useTranslations } from 'next-intl';
// import { useSearchParams } from 'next/navigation';

const OrderCard = ({ order }: { order: ISingleOrder }) => {
  const t = useTranslations();
  const getColor = (color: string) => {
    switch (color) {
      case 'preorder':
        return 'orange';
      case 'cancelled':
        return 'red';
      case 'active':
        return 'blue';
      case 'finished':
        return 'green';
      case 'active':
        return 'blue';

      default:
        return 'black';
    }
  };

  dayjs.locale('ru');
  return (
    <HStack py={4} justify="space-between" w="full">
      <VStack align="start" gap={1}>
        <HStack fontWeight="semibold">
          <Text>{order.shipper.name}</Text>
        </HStack>
        <Text fontSize="sm" color="text.muted">
          {order.created_at && dayjs(order.created_at).format('D MMMM HH:mm')}
        </Text>
      </VStack>
      <VStack>
        <HStack fontWeight="semibold" gap="6px">
          <NumberToPrice
            spanProps={{
              fontWeight: 600,
            }}
            value={
              (order?.order_amount || 0) +
              (order?.delivery_price || 0) +
              (order?.service_fee || 0)
            }
          />
          <RightIcon color="currentColor" />
        </HStack>
        <Badge
          size={'sm'}
          rounded={'full'}
          textAlign={'center'}
          justifyContent={'center'}
          alignSelf='end'
          colorPalette={
            order.status_id ? getColor(getStatus(order.status_id)) : undefined
          }
        >
          <Text
            color={order.status_id ? getColor(getStatus(order.status_id)) : ''}
          >
            {order?.delivery_type === 'hall' && order?.pos_id
              ? t(`order_list.vendor-accepted`)
              : order?.status_id
                ? t(`order_list.${getStatusName(order?.status_id)}`)
                : ''}
          </Text>
        </Badge>
      </VStack>
    </HStack>
  );
};

export default OrderCard;
